/* Let's Mix — homepage behaviours (reveals, quick add) */
(function () {
  'use strict';

  /* ---- Scroll reveals ---- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.lm-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header offset (Flow header may float over the hero) ---- */
  function setHeaderOffset() {
    var wrap = document.getElementById('shopify-section-header') || document.querySelector('.header-section');
    if (!wrap) return;
    var overlay = wrap.getBoundingClientRect().height < 10; /* Flow "overlay" header collapses its wrapper */
    if (!overlay) { document.documentElement.style.setProperty('--lm-header-offset', '0px'); return; }
    var h = 0;
    wrap.querySelectorAll('.site-header, .mobile-nav__logo-title, .mobile-nav, header').forEach(function (el) {
      if (el.closest('.drawer')) return;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height > h && r.height < 200) h = r.height;
    });
    document.documentElement.style.setProperty('--lm-header-offset', Math.round(h || 70) + 'px');
  }

  /* ---- Cart helpers ---- */
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function updateCartCount(cart) {
    var nodes = document.querySelectorAll('.cart-item-count-header--quantity, .cart-item-count-header, [data-cart-count], .site-header__cart-indicator');
    nodes.forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.remove('hide');
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('lm:cart:added', { detail: cart }));
  }

  function handleQuickAdd(form) {
    var btn = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!btn || !idInput || !idInput.value) return;
    var original = btn.getAttribute('data-label') || btn.textContent.trim();
    btn.setAttribute('data-label', original);
    btn.setAttribute('data-state', 'adding');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding…';

    /* App-option validation (Globo etc.) — if a required field is flagged, stop and let the app show its message */
    if (form.querySelector('.gpo-element.has-error, .gpo-error-message')) {
      btn.removeAttribute('data-state'); btn.textContent = original;
      var firstErr = form.querySelector('.gpo-element.has-error');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    /* Mix & Match bottle picker — every bottle must have a flavour */
    var pick = form.querySelector('[data-lm-pick]');
    if (pick) {
      var missing = Array.prototype.filter.call(pick.querySelectorAll('[data-lm-pick-group]'), function (g) { return !g.querySelector('input:checked'); });
      var errEl = pick.querySelector('[data-lm-pick-error]');
      if (missing.length) {
        btn.removeAttribute('data-state'); btn.textContent = original;
        missing.forEach(function (g) { g.classList.add('is-missing'); });
        if (errEl) { errEl.textContent = pick.getAttribute('data-error') || 'Choose a flavour for every bottle first.'; errEl.hidden = false; }
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (errEl) errEl.hidden = true;
    }

    /* Send the WHOLE form (id, quantity, properties[...] from option apps, selling plan) so nothing is lost */
    var fd = new FormData(form);
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!fd.has('quantity')) fd.set('quantity', qtyInput ? Number(qtyInput.value) || 1 : 1);
    fd.delete('form_type'); fd.delete('utf8');
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (typeof v === 'string') params.append(k, v); });

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: params.toString()
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart);
        btn.setAttribute('data-state', 'added');
        btn.textContent = btn.getAttribute('data-added') || 'Added to bag';
        form.classList.add('is-added');
        var sub = form.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = formatMoney(cart.total_price);
        setTimeout(function () {
          btn.removeAttribute('data-state');
          btn.textContent = original;
        }, 2600);
      })
      .catch(function (err) {
        btn.removeAttribute('data-state');
        btn.textContent = original;
        if (err && err.json) {
          err.json().then(function (j) { alert(j.description || j.message || 'Sorry, we could not add that to your bag.'); })
            .catch(function () { form.submit(); });
        } else {
          form.submit(); /* fall back to the standard cart page */
        }
      });
  }

  function bindQuickAdd(root) {
    (root || document).querySelectorAll('form[data-lm-quick-add]').forEach(function (form) {
      if (form.__lmBound) return;
      form.__lmBound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleQuickAdd(form);
      });
      /* variant select → price sync */
      var sel = form.querySelector('select[name="id"]');
      var price = form.closest('[data-lm-product]') ? form.closest('[data-lm-product]').querySelector('[data-lm-price]') : null;
      if (sel && price) {
        sel.addEventListener('change', function () {
          var opt = sel.options[sel.selectedIndex];
          if (opt && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
          var submit = form.querySelector('[type="submit"]');
          if (submit) {
            var available = opt.getAttribute('data-available') !== 'false';
            submit.disabled = !available;
            submit.textContent = available ? (submit.getAttribute('data-label') || submit.textContent) : (submit.getAttribute('data-soldout') || 'Sold out');
          }
        });
      }
    });
  }

  /* Collection sort: submit on change, keep the user at the grid */
  function bindSort(root) {
    (root || document).querySelectorAll('form[data-lm-sort]').forEach(function (form) {
      if (form.__lmBound) return;
      form.__lmBound = true;
      var sel = form.querySelector('select');
      if (!sel) return;
      sel.addEventListener('change', function () {
        var url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sel.value);
        params.delete('page');
        url.search = params.toString();
        url.hash = 'products';
        window.location.assign(url.toString());
      });
    });
  }

  /* Video sections: sound toggle for autoplaying loops */
  function bindVideos(root) {
    (root || document).querySelectorAll('[data-lm-video]').forEach(function (frame) {
      if (frame.__lmBound) return;
      frame.__lmBound = true;
      var video = frame.querySelector('video');
      var btn = frame.querySelector('[data-lm-sound]');
      if (!video) return;
      if (!btn) { btn = null; }
      var label = btn ? btn.querySelector('[data-lm-sound-label]') : null;
      if ('IntersectionObserver' in window && video.autoplay) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); }
          });
        }, { threshold: 0.2 });
        io.observe(video);
      }
      if (!btn) return;
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.classList.toggle('is-on', !video.muted);
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        if (label) label.textContent = video.muted ? 'Sound on' : 'Mute';
        if (video.paused) video.play().catch(function () {});
      });
    });
  }

  function init(root) {
    setHeaderOffset();
    initReveals(root);
    bindQuickAdd(root);
    bindSort(root);
    bindVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  window.addEventListener('resize', setHeaderOffset);
  window.addEventListener('load', setHeaderOffset);

  /* Theme editor: re-init when a section is (re)rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
  /* ---- Announcement bar: rotate messages on small screens ---- */
  (function rotateAnnounce() {
    var bar = document.querySelector('[data-lm-announce]');
    if (!bar) return;
    var items = bar.querySelectorAll('.lm-announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth >= 900) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3800);
  })();

  /* Mix & Match bottle picker — show the chosen flavour in the legend */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.name || input.name.indexOf('properties[Bottle #') !== 0) return;
    var group = input.closest('[data-lm-pick-group]');
    if (!group) return;
    group.classList.remove('is-missing');
    var st = group.querySelector('[data-lm-pick-status]');
    if (st) st.textContent = '— ' + input.value;
    var pick = group.closest('[data-lm-pick]');
    var errEl = pick && pick.querySelector('[data-lm-pick-error]');
    var stillMissing = Array.prototype.some.call(pick.querySelectorAll('[data-lm-pick-group]'), function (g) { return !g.querySelector('input:checked'); });
    if (errEl && !stillMissing) errEl.hidden = true;
  });
})();